import LoggedInBoilerplate from "../../LoggedInBoilerplate";
import { useEffect, useState } from "react";
import LoadingSection from "../../../../helperComponents/LoadingSection";
import getUrlQuery from "../../../../../controllers/getUrlQuery";
import fetchDataWithCaching from "../../../../../controllers/network/fetchDataWithCaching";
import PullToRefresh from "react-simple-pull-to-refresh";
import ActivityTypeDetails from "./ActivityTypeDetails";

export default function ActivityTypeDetailsPage() {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    doLoading(false);
  }, []);

  async function doLoading(skipCache) {
    if (skipCache) setLoading(true);
    let urlQuery = getUrlQuery();

    let newData = await fetchDataWithCaching({
      path: `/activity-type/?itemID=${urlQuery.itemID}`,
      skipCache,
      setLoading,
      onFreshData: setItem,
    });

    setLoading(false);
    setItem(newData);
  }

  async function handleRefresh() {
    await doLoading(true);
  }

  if (loading || !item)
    return (
      <LoggedInBoilerplate allowWithoutLogin={true}>
        <LoadingSection />
      </LoggedInBoilerplate>
    );

  return (
    <LoggedInBoilerplate allowWithoutLogin={true}>
      <PullToRefresh onRefresh={handleRefresh}>
        <ActivityTypeDetails
          doLoading={doLoading}
          item={item.activityType}
          bookingData={item.booking}
        />
      </PullToRefresh>
    </LoggedInBoilerplate>
  );
}
